import * as v from 'valibot';

import { type Pricing, pricingSchema } from '@/modules/pricing';

export const contractPricingLinkApiSchema = v.object({
  contractKey: v.string(),
  createdBy: v.number(),
  createdOn: v.string(),
  key: v.string(),
  modifiedBy: v.nullish(v.number()),
  modifiedOn: v.nullish(v.string()),
  pricingId: v.number(),
});

export const contractPricingSearchApiSchema = v.object({
  items: v.array(contractPricingLinkApiSchema),
  totalCount: v.number(),
});

export const pricingLinksApiSchema = v.array(contractPricingLinkApiSchema);

export const linkPricingApiSchema = v.pick(contractPricingLinkApiSchema, ['contractKey', 'pricingId']);

// Subset of PricingHeader: fields needed for the contract pricing table
export const pricingHeaderApiSchema = v.object({
  branchKey: v.nullish(v.number()),
  cargoType: v.nullish(v.string()),
  carrierKey: v.nullish(v.number()),
  currencyCode: v.nullish(v.string()),
  pricingBasis: v.nullish(v.string()),
  pricingKey: v.number(),
  pricingType: v.nullish(v.string()),
  serviceKey: v.nullish(v.number()),
});

export const contractPricingItemSchema = v.pick(pricingSchema, [
  'branch',
  'cargoType',
  'carrier',
  'currency',
  'id',
  'pricingBasis',
  'pricingKey',
  'pricingType',
  'service',
]);

export const contractPricingSchema = v.object({
  items: v.array(contractPricingItemSchema),
  totalCount: v.number(),
});

export const contractPricingParamsSchema = v.object({
  contractKey: v.string(),
  limit: v.optional(v.pipe(v.number(), v.minValue(0)), 10),
  offset: v.optional(v.pipe(v.number(), v.minValue(0)), 0),
  pricingId: v.optional(v.number()),
  sorting: v.optional(v.string()),
});

export type ContractPricingLinkApi = v.InferOutput<typeof contractPricingLinkApiSchema>;
export type ContractPricingSearchApi = v.InferOutput<typeof contractPricingSearchApiSchema>;
export type LinkPricingApi = v.InferInput<typeof linkPricingApiSchema>;
export type PricingHeaderApi = v.InferOutput<typeof pricingHeaderApiSchema>;
export type ContractPricingItem = v.InferOutput<typeof contractPricingItemSchema>;
export type ContractPricing = v.InferOutput<typeof contractPricingSchema>;
export type ContractPricingParams = v.InferOutput<typeof contractPricingParamsSchema>;

export type ContractPricingRawItem = {
  key: string;
  pricing: PricingHeaderApi;
};

export type ContractPricingRaw = {
  items: ContractPricingRawItem[];
  totalCount: number;
};

export type LinkPricingParams = {
  contractKey: string;
  pricing: Pricing[];
};
